// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface AccountSettings {
    lastName: string;
    firstName: string;
    properties: {
        phone: string;
        language: string;
    };
    phoneError: string;
}

const initialHeaderState: AccountSettings = {
    lastName: "",
    firstName: "",
    properties: {
        phone: "",
        language: "",
    },
    phoneError: "",
};

const reducer = {
    "xAccountSettings/updateAccountSettings": (
        draft: Draft<AccountSettings>,
        action: {
            lastName: string;
            firstName: string;
            properties: {
                phone: string;
                language: string;
            };
            phoneError?: string;
        },
    ) => {
        action?.properties?.language && (draft.properties.language = action.properties.language);
        typeof action.lastName === "string" && (draft.lastName = action.lastName);
        typeof action.firstName === "string" && (draft.firstName = action.firstName);
        typeof action?.properties?.phone === "string" && (draft.properties.phone = action?.properties?.phone);

        if (action?.properties && !action?.properties.phone && !action?.properties.language) {
            draft.properties.phone = "";
        }
        if (action.phoneError) {
            draft.phoneError = action.phoneError;
        } else {
            draft.phoneError = "";
        }
    },
};

const xAccountSettings = createTypedReducerWithImmer(initialHeaderState, reducer);

(reducers as any).xAccountSettings = xAccountSettings;

export type xAccountSettingsState = {
    xAccountSettings: AccountSettings;
};

type xAccountSettingsReducers = {
    lastName: typeof xAccountSettings;
    firstName: typeof xAccountSettings;
    phone: typeof xAccountSettings;
    language: typeof xAccountSettings;
};

export type xAccountSettingsActions =
    | Parameters<xAccountSettingsReducers[keyof xAccountSettingsReducers]>[1]
    | AnyAction;
